import {Component, inject, OnInit} from '@angular/core';
import {DialogOngoingAnalysisService} from "../../services/dialog-ongoing-analysis.service";
import {Router} from "@angular/router";
import {Product} from "../../../core/models/product";
import {Utils} from "../../utils/generics.utils";
import {AppStateService} from "../../../core/state/app-state.service";

@Component({
    selector: 'app-dialog-ongoing-analysis',
    templateUrl: './dialog-ongoing-analysis.component.html',
    styleUrls: ['./dialog-ongoing-analysis.component.scss'],
    standalone: false
})
export class DialogOngoingAnalysisComponent implements OnInit {

  private dialogService = inject(DialogOngoingAnalysisService);
  private router = inject(Router);
  private appStateService = inject(AppStateService);

  shown$ = this.dialogService.shown$;

  ngOnInit(): void {
  }

  onClose() {
    this.dialogService.hide();
  }

  async cancel() {
    await this.appStateService.clear();
    let route = '/';
    const fleet = this.appStateService.fleet();
    const company = Utils.extractSubcompany();
    const product = this.appStateService.product();
    if (fleet) {
      if (product === Product.DIAGNOSIS) {
        if (company) {
          route = `/diagnosis/${fleet}/company/${company}/license`
        } else {
          route = `/diagnosis/${fleet}/license`
        }
      } else if (product === Product.SCANNER) {
        if (company) {
          route = `/scanner/${fleet}/company/${company}/license`
        } else {
          route = `/scanner/${fleet}/license`
        }
      } else if (product === Product.COLLECT) {
        if (company) {
          route = `/collect/${fleet}/company/${company}/license`
        } else {
          route = `/collect/${fleet}/license`
        }
      }
    }
    this.router.navigate([route], {queryParams: {nocheck: true, beta: this.appStateService.beta()}}).then();
    this.dialogService.hide();
  }

}
